import { AddRounded, EditRounded, ExpandLess, ExpandMore, KeyboardArrowUp, PersonRounded } from "@mui/icons-material";
import { Box, Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import {
	allStylesPath,
	attrConditionalDisplayColObj,
	attrGroupLinkedTables,
	attrGrpTableStrColumnsObj,
	attrTableStrColumnsObj,
	styleFileAssocObj,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { AuthState } from "context/AuthContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { datatypes, inputTypes, statusOptions, arrType, getRelProtectedFileSignedUrl } from "data/globalData";
import { attrGrpAttrAssocObj, attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import { useEffect, useState } from "react";
import axios from "axios";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import RenderStyleInputField from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/RenderStyleInputFieldNU/RenderStyleInputField";
import AddNewImageModal, { isMainImg } from "../../AddNewImageModal/AddNewImageModal";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
	NAOption,
	styleFileColumns,
	styleImgDepartmentCol,
	styleUrlKey,
} from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";
import DisplayStyleDetailsWithEditTab from "./DisplayStyleDetailsWithEditTab/DisplayStyleDetailsWithEditTab";
import EditImageDataModal from "../../EditImageDataModal/EditImageDataModal";
import ColorsSection from "./ColorsSection/ColorsSection";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { custom, departments } from "data/authData";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
const imgWidth = 220;
const imgHeight = 280;

const SelectedStyle = () => {
	const { user } = AuthState();
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();
	const { selectedStyle, setSelectedStyle, attrGroupsWithAttr } = PimDashboardState();
	let [searchParams, setSearchParams] = useSearchParams();

	const disableEdit = user?.role?.[custom.STYLE_VIEWER.key] === true;
	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setSelectedStyle();
			try {
				const res = await axios.get(`/api/designer/style_by_id/${styleId}`);
				setSelectedStyle(res.data);
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		let styleId = searchParams.get(styleUrlKey);
		if (styleId && styleId !== selectedStyle?.id) fetch();
		else {
			setSelectedStyle(null);
		}
	}, [searchParams]);

	const navigate = useNavigate();

	const [addNewImgModal, setAddNewImgModal] = useState(false);
	const [imgInfoModal, setImgInfoModal] = useState(false);

	const handleFileUpload = async (files, data) => {
		const formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append("files", files[i].file);
		}
		formData.append("style_id", data?.[attrGroupLinkedTables.style.key]?.style_id);

		return await axios
			.post("/api/designer/multiple_image_upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return "Error in file Upload";
			});
	};
	const handleDesignerFileAdd = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", JSON.stringify(newFileData));

		const uploadToBucket = await axios.post("/api/upload/single_upload_to_rel_bucket", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		const res = await axios.post("/api/designer/create_style_file_sql", {
			...uploadToBucket.data.result,
			style_id: selectedStyle[attrGroupLinkedTables.style.key].style_id,
		});
		setSelectedStyle((prev) => ({
			...prev,
			[attrGroupLinkedTables?.style.key]: {
				...prev?.[attrGroupLinkedTables.style.key],
				[styleFileAssocObj]: [...prev?.[attrGroupLinkedTables.style.key][styleFileAssocObj], res.data.result],
			},
		}));
		return true;
	};
	const handleDesignerFileDelete = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", newFileData);
		setLoadingOpen(true);
		try {
			const res = await axios.delete(`/api/designer/delete_style_file_sql/${newFileData.id}`);
			if (res) {
				setSelectedStyle((prev) => ({
					...prev,
					[attrGroupLinkedTables?.style.key]: {
						...prev?.[attrGroupLinkedTables.style.key],
						[styleFileAssocObj]: prev?.[attrGroupLinkedTables.style.key][styleFileAssocObj]?.filter(
							(row) => row?.id != newFileData.id,
						),
					},
				}));
				setLoadingOpen(false);
				return true;
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
		return true;
	};

	const handleDesignerFileDownload = async (row) => {
		{
			try {
				setLoadingOpen(true);
				const fileUrl = await getRelProtectedFileSignedUrl(row?.url);
				if (fileUrl) {
					window.open(fileUrl, "_blank");
					setSnackBarOpen(true);
					setSnackBar({ ...snackBar, message: "File Downloaded Successfully", severity: "success" });
					setLoadingOpen(false);
				}
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
				setLoadingOpen(false);
			}
		}
	};
	const updateMainImage = async (data) => {
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/designer/change_main_image", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Main Image Changed Sucessfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			if (res)
				setSelectedStyle({
					...selectedStyle,
					[attrGroupLinkedTables.style.key]: {
						...selectedStyle[attrGroupLinkedTables.style.key],
						[styleImagesAssocObj]: selectedStyle[attrGroupLinkedTables.style.key][styleImagesAssocObj]?.map((row) => {
							if (row.id === data.id) return { ...row, is_main: true };
							else return { ...row, is_main: false };
						}),
					},
				});
			setLoadingOpen(false);

			setImgInfoModal(false);
			return true;
		} catch (error) {
			console.log(error);
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return false;
		}
	};
	const addNewImages = async (images, mainImgIndex) => {
		setLoadingOpen(true);

		const imageUrls = await handleFileUpload(images, selectedStyle);

		const productImages = imageUrls.map((row, index) => {
			return { style_id: selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id, is_main: false, url: row.publicUrl };
		});

		try {
			const res = await axios.post("/api/designer/bulk_create_images_sql", productImages);

			setSelectedStyle({
				...selectedStyle,
				[attrGroupLinkedTables.style.key]: {
					...selectedStyle[attrGroupLinkedTables.style.key],
					[styleImagesAssocObj]: [
						...selectedStyle[attrGroupLinkedTables.style.key][styleImagesAssocObj],
						...res.data.result,
					],
				},
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Images created Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			setLoadingOpen(false);

			return true;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
	};

	const goToStylesPage = () => {
		navigate(allStylesPath);
	};

	const updateStyleDetailsFun = async (data, modelCloseFun, attrGrp) => {
		if (data) {
			try {
				const res = await axios.put(
					`/api/designer/update_style_data/${attrGrp?.linked_table}?group_id=${attrGrp?.group_id}`,
					data,
				);

				setSelectedStyle({
					...selectedStyle,
					[attrGrp.linked_table]: data,
					res,
				});
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data saved successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
					res,
				});
				modelCloseFun();
			} catch (error) {
				console.log(error, "hgfghrdfdggggggghjk");
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
			}
		}
	};

	if (selectedStyle)
		return (
			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
				{/* <Divider variant="fullWidth" orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} /> */}

				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
				{/* colors section */}
				<Box display="flex" justifyContent="space-around" width="100%">
					{/* left */}
					<Box>
						<Box width={imgWidth} height={imgHeight}>
							<ImageSlider
								imgWidth={imgWidth}
								imgHeight={imgHeight}
								column="url"
								images={
									selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleImagesAssocObj]?.length
										? selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleImagesAssocObj]
										: []
								}
							/>
						</Box>
						{console.log(selectedStyle, "dsfsdvbn")}
						<Box p={1} display="flex" columnGap={2}>
							<IconButton
								disabled={disableEdit}
								startIcon={<EditRounded sx={{ color: "#fff" }} />}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
									// width: 100,
								}}
								variant="contained"
								onClick={() => setImgInfoModal(true)}>
								<EditRounded sx={{ color: "white" }} />
							</IconButton>
							<IconButton
								disabled={disableEdit}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
								}}
								variant="contained"
								onClick={() => setAddNewImgModal(true)}>
								<AddRounded sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					</Box>
					<Divider orientation="vertical" flexItem />
					{/* right */}
					<Box sx={{ width: "78%" }}>
						{/* style Table Columns */}
						{Object.keys(attrGroupsWithAttr)
							.reduce((acc, row) => {
								if (
									attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
									attrGroupLinkedTables.style.key
								)
									acc.push(attrGroupsWithAttr[row]);
								return acc;
							}, [])
							?.map((row) => {
								return (
									<DisplayStyleDetailsWithEditTab
										columns={[...row[attrGrpAttrAssocObj]]}
										data={selectedStyle}
										setData={setSelectedStyle}
										attrGrp={row}
										disableEdit={true}
										updateFunction={updateStyleDetailsFun}
										width="32%"
									/>
								);
							})}
					</Box>
				</Box>
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />
				<ColorsSection colorsArr={selectedStyle?.[attrGroupLinkedTables.color.key]} disableEdit={disableEdit} />
				<Box width="100%" pt={2} />
				{/* style Details Table Columns */}
				{Object.keys(attrGroupsWithAttr)
					.reduce((acc, row) => {
						if (
							attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
							attrGroupLinkedTables.style_details.key
						)
							acc.push(attrGroupsWithAttr[row]);
						return acc;
					}, [])
					// .filter((row) => row.group_id !== "fabric_details")
					?.map((row) => {
						return (
							<DisplayStyleDetailsWithEditTab
								columns={[...row[attrGrpAttrAssocObj]]}
								data={selectedStyle}
								setData={setSelectedStyle}
								attrGrp={row}
								updateFunction={updateStyleDetailsFun}
								disableEdit={row.group_id !== "fabric_details" ? disableEdit : true}
							/>
						);
					})}

				<Divider sx={{ width: "100%", mt: 2, mb: 1 }} orientation="horizontal" />
				<AddFiles
					addNewDefault={{ [styleImgDepartmentCol.key]: departments.DESIGNER.key }}
					columns={styleFileColumns}
					handleAddFile={handleDesignerFileAdd}
					files={selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleFileAssocObj] ?? []}
					setFiles={(files) => {
						setSelectedStyle((prev) => ({
							...prev,
							[attrGroupLinkedTables?.style.key]: {
								...prev?.[attrGroupLinkedTables.style.key],
								[styleFileAssocObj]: files,
							},
						}));
					}}
					handleDelete={handleDesignerFileDelete}
					handleDownload={handleDesignerFileDownload}
				/>
				{/* add Images Modal */}

				{addNewImgModal && (
					<AddNewImageModal modalOpen={addNewImgModal} setModalOpen={setAddNewImgModal} submitFunction={addNewImages} />
				)}
				{imgInfoModal && (
					<EditImageDataModal modalOpen={imgInfoModal} setModalOpen={setImgInfoModal} submitFunction={updateMainImage} />
				)}
			</Box>
		);
	else {
		if (!Loadingopen)
			return (
				<Stack display="flex" justifyContent="center" alignItems="center" height="100%" spacing={1}>
					<Typography variant="h5" p={2}>
						---- No Style Id Found ----
					</Typography>
					<Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={goToStylesPage}>
						Go to All Styles
					</Button>
				</Stack>
			);
	}
};

export default SelectedStyle;
